<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                <show-field :value="item.nombre" :label="$t('recargo.labels.nombre')" icon="expand-all"/>
                <show-field :value="item.recargo" :label="$t('recargo.labels.recargo')" icon="expand-all"/>
                <show-field :value="depositoNombre" :label="$t('recargo.labels.deposito')" icon="store"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
            </v-list>
        </v-col>
    </v-row>
</template>
<script>
import { ShowField } from '@dracul/common-frontend';

export default {
    name: 'RecargoShowData',
    components: { ShowField },

    props: {
        item: { type: Object, required: true }
    },

    computed: {
        depositoNombre() {
            const d = this.item && this.item.deposito;
            if (!d) return '—';
            return d.nombre || d.id || '—';
        }
    }
};
</script>
